import { Routes } from '@angular/router';
import { ProjectsListComponent } from '@projects/projects-list/projects-list.component';
import { ProjectsDetailComponent } from '@projects/projects-detail/projects-detail.component';

export const ProjectsRoutes: Routes = [
  {
    path: '',
    component: ProjectsListComponent,
    data: { titleKey: 'routes.projects' },
  },
  {
    path: ':projectId',
    component: ProjectsDetailComponent,
    data: { titleKey: 'routes.projectDetails' },
  },
];
